import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioRecordatorioCitasService {

  constructor( private requestUrl: ReportesRequestService ) { }

  public async getDataRecordatorioCitas( codigoBaseDatos: string, uncoCirugia: string ) {
    try {
      const response = await this.requestUrl.getRequest(
        'reporte-recordatorio-citas/data',
        [
          codigoBaseDatos,
          {
            'ln_unco_trno_crga': uncoCirugia
          }

        ]
      );

      return response;

    } catch (e) {
      console.log(e);
    }

    return null;
  }

}

export interface ParametroRecordatorioEntity {
  codigoBaseDatos: string;
  uncoSede: number;
  uncoLogin: number;
  uncoCita: number;
}

export interface RecordatorioCitasEntity {
  unco ?: number;
  fecha ?: number;
  sede: string;
  puntoAtencion: string;
  profesionalSalud: string;
  identificacionAfiliado: string;
  afiliado: string;
  telefonoAfiliado: string;
  periodoInical: string;
  duracion: string;
  fechaCita: string;
  mes: string;
  dia: string;
  autorizacionConsultaExterna: string;
  empresa: string;
  procedimiento: string;
  codigoProcedimiento: string;
  tipoDocumento: string;
  direccionSede: string;
  telefonoMovil: string;
  telefonoPbx: string;
  tipoHora: string;
  detalleCita: string;
  usuarioCreacion ?: string;
}
